import React, { useEffect, useState } from "react";

import axios from "../../helpers/axios";
import { PartStatus } from "../../helpers/parts";

const PartStatusLog = (props) => {
  const [log, setLog] = useState([]);

  const loadData = (id) => {
    axios.get(`/api/parts/${id}/log/`).then((response) => {
      let log = response.data.map((l) => {
        l.timestamp = new Date(l.timestamp);
        return l;
      });

      for (let i = 0; i < log.length; i++) {
        if (i + 1 < log.length) {
          log[i].delta = log[i + 1].timestamp - log[i].timestamp;
        } else {
          log[i].delta = new Date() - log[i].timestamp;
        }
      }

      setLog(log);
    });
  };

  useEffect(() => {
    loadData(props.id);
  }, [props.id]);

  return (
    <table className="table is-fullwidth">
      <thead>
        <tr>
          <th>Status</th>
          <th>Fecha</th>
          <th>Tiempo</th>
        </tr>
      </thead>
      <tbody>
        {log.map((l) => (
          <tr key={l.id}>
            <td>
              <span
                className={`tag ${PartStatus[l.status].color}`}
                title={PartStatus[l.status].label}
              >
                {PartStatus[l.status].key}
              </span>
            </td>
            <td>{l.timestamp.toLocaleString()}</td>
            <td>{Math.ceil(l.delta / (24 * 36000 * 1000))}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PartStatusLog;
